import React from 'react';
import LoadingOverlay from 'eventbrite_design_system/loadingOverlay/LoadingOverlay';

export default class LoadingPage extends React.PureComponent {
    render() {
        return <LoadingOverlay isShown={true} />;
    }
}
